let initRecommenderFns = [];

export function registerProductRecommenderInit(fn)
{
    if (typeof fn === 'function') {
        initRecommenderFns.push(fn);
    }
}

export function initRecommender(recommender, productType)
{
    initRecommenderFns.forEach(function(fn) {
        fn(recommender, productType);
    });
}
